import {StyleSheet} from "aphrodite";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import {font, sizing} from "@khanacademy/wonder-blocks-tokens";
import {FormattedText} from "@khan/guide-ui";

import type {JsonPath, MaybePlaceholder} from "../../types.ts";
import {isPlaceholder} from "../../utils.ts";
import EditableItem from "../editable-item.tsx";
import PlaceholderBlock from "../placeholder-block.tsx";

import type {AnswerData} from "./types.ts";

const StyledLi = addStyle("li");

interface Props {
    answer: MaybePlaceholder<AnswerData>;
    path: JsonPath;
}

export default function AnswerNode({answer, path}: Props) {
    if (isPlaceholder(answer)) {
        return (
            <StyledLi style={styles.li}>
                <PlaceholderBlock placeholderKey={answer.$placeholder} />
            </StyledLi>
        );
    }

    const {text} = answer;

    return (
        <EditableItem path={path} tag={StyledLi} style={styles.li}>
            <FormattedText text={text} />
        </EditableItem>
    );
}

const styles = StyleSheet.create({
    li: {
        display: "list-item",
        paddingInlineStart: sizing.size_080,
        fontSize: font.size.medium,
    },
});
